import isEqual from 'lodash.isequal';
import { CustomRoutePath, CustomRouteSegment, GroupedSegment } from '../../types/CustomRoute';

export const isSinglePointSegment = (segment: Pick<CustomRouteSegment, 'paths'>) => {
  return segment.paths.length === 1 && segment.paths[0].points.length === 1;
};

export const isPathRoutable = (path: CustomRoutePath): boolean => {
  return path.points.length > 1;
};

export const isSegmentRoutable = (segment: CustomRouteSegment): boolean => {
  return segment.paths.length > 0 && isPathRoutable(segment.paths[0]);
};

export const isGroupedSegmentRoutable = (groupedSegment: GroupedSegment): boolean => {
  return (
    groupedSegment.pathGroups.length > 0 && groupedSegment.pathGroups[0].paths.length > 0 && isPathRoutable(groupedSegment.pathGroups[0].paths[0])
  );
};

export function doEndsCoincide(segments: CustomRouteSegment[] | undefined): boolean | undefined {
  if (!segments?.length) {
    return undefined;
  }

  const firstSegment = segments[0];
  const lastSegment = segments[segments.length - 1];

  if (!firstSegment?.paths?.length || firstSegment.paths[0].points.length < 2 || !lastSegment?.paths?.length) {
    return undefined;
  }

  const startPoint = firstSegment.paths[0].points[0];
  const endPath = lastSegment.paths[lastSegment.paths.length - 1];
  if (!endPath.points?.length) {
    return undefined;
  }
  const endPoint = endPath.points[endPath.points.length - 1];

  return isEqual(startPoint, endPoint);
}
